export const SETVOLUNTEERTAGSDROPDOWNLOADING =
  "SETVOLUNTEERTAGSDROPDOWNLOADING";
export const SETVOLUNTEERTAGSDROPDOWNDATA = "SETVOLUNTEERTAGSDROPDOWNDATA";
export const SETTAGSDROPDOWNLOADING = "SETTAGSDROPDOWNLOADING";
export const SETTAGSDROPDOWNDATA = "SETTAGSDROPDOWNDATA";
